import { IpesEmbeddedPortalButton } from "./IpesEmbeddedPortalButton";
import { IpesEmbeddedPortalDialog } from "./IpesEmbeddedPortalDialog";
import {
  useIpesEmbeddedPortal,
  type IpesPatientLike,
} from "./useIpesEmbeddedPortal";
import type { SxProps, Theme } from "@mui/material/styles";

// Acesso a "Informações de outras redes" (portal IPES) desativado temporariamente.
// O código foi mantido de propósito: a funcionalidade volta no futuro.
// Para reativar em todas as telas (atendimento e prontuário), basta trocar para `true`.
export const IPES_EMBEDDED_PORTAL_ENABLED = false;

export interface IpesEmbeddedPortalAccessProps {
  patientCpf?: string;
  patient?: IpesPatientLike;
  patientCpfFallbacks?: Array<string | undefined>;
  fullWidth?: boolean;
  buttonSx?: SxProps<Theme>;
}

/**
 * Fachada para o legado: botão + dialog, só para profissional.
 * O Dialog usa portal do MUI e não ocupa espaço no flex da toolbar.
 */
export function IpesEmbeddedPortalAccess({
  patientCpf,
  patient,
  patientCpfFallbacks,
  fullWidth,
  buttonSx,
}: IpesEmbeddedPortalAccessProps) {
  const { isOpen, iframeUrl, isProfessional, open, close } =
    useIpesEmbeddedPortal({
      patientCpf,
      patient,
      patientCpfFallbacks,
    });

  // A flag fica depois do hook para respeitar a regra dos hooks do React.
  if (!IPES_EMBEDDED_PORTAL_ENABLED || !isProfessional) return null;

  return (
    <>
      <IpesEmbeddedPortalButton
        onClick={() => {
          void open();
        }}
        fullWidth={fullWidth}
        sx={buttonSx}
      />
      <IpesEmbeddedPortalDialog
        open={isOpen}
        iframeUrl={iframeUrl}
        onClose={close}
      />
    </>
  );
}
